// @flow
import React, { Fragment, PureComponent } from 'react';
import { Link, Redirect } from 'react-router-dom';
import type { CentenaireClubPreviewType } from 'types/Centenaire';
import type { FullUserType } from 'types/User';
import { queryCentenaireClubsAndCities } from 'utils/centenaireUtils';
import { sendTags, handleTagEvent } from 'utils/tagManagerUtils';

export type DispatchProps = {
  setQueryCentenaire: (queryCentenaire: string) => void,
};

export type StateProps = {
  userPref: FullUserType,
};

type Props = StateProps & {
  clubs: Array<CentenaireClubPreviewType>,
  handleInputClicked: Function,
  handleClickOutside: Function,
} & DispatchProps;

type State = {
  cities: string[],
  clubs: CentenaireClubPreviewType[],
  queryCentenaire: string,
  redirect: boolean
};

class CentenaireSearch extends PureComponent<Props, State> {
  props: Props;
  state: State = {
    cities: [],
    clubs: [],
    queryCentenaire: '',
    redirect: false
  };
  _input: ?HTMLElement;

  handleClick = (param: Object) => {
    this.props.handleClickOutside();
  }

  renderCities = (): any => {
    return this.state.cities.map((city, index) => (
      <li key={index}>
        <Link
          to={{
            pathname: '/histoires-de-rugby/resultats-de-recherche',
            state: {
              queryCentenaire: city
            }
          }}
          onClick={() => {
            this.props.setQueryCentenaire(city);
            sendTags(
              'recherche_centenaire',
              'clic_result_villes',
              city,
            );
            this.handleClick({ city });
          }}
        >
          {city}
        </Link>
      </li>
    ));
  };

  renderClubs = (): any => {
    return this.state.clubs.map((club, index) => (
      <li key={index}>
        <Link
          to={{
            pathname: '/histoires-de-rugby/resultats-de-recherche',
            state: {
              queryCentenaire: club.name.toLowerCase()
            }
          }}
          onClick={() => {
            this.props.setQueryCentenaire(club.name);
            sendTags(
              'recherche_centenaire',
              'clic_result_clubs',
              club.name,
            );
            this.handleClick({ club: club.name });
          }}
        >
          <img src={club.img} alt={club.name} width="16" height={16} />
          {club.name}
        </Link>
      </li>
    ));
  };

  handleClickOutside = (e: any) => {
    if (this._input && !this._input.contains(e.target)) {
      this.props.handleClickOutside();
    }
  };

  handleInputChanged = (e: any) => {
    const queryCentenaire = e ? e.target.value.toLowerCase() : '';
    this.setState({queryCentenaire});
    queryCentenaireClubsAndCities(this.props.clubs, queryCentenaire)
      .then(({ cities, clubs }) => this.setState({ cities, clubs, queryCentenaire }));
  };

  handleSubmit = () => {
    this.props.setQueryCentenaire(this.state.queryCentenaire);
    this.props.handleClickOutside();
    this.setState({ redirect: true });
  };

  componentDidUpdate(prevProps: Props) {
    if (prevProps.clubs.length === 0 && this.props.clubs.length > 0) {
      this.handleInputChanged(null);
    }
    if (this.state.redirect)
      this.setState({redirect: false});
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    this.handleInputChanged(null);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  render() {
    const { userPref } = this.props;

    if (this.state.redirect) {
      return (
        <Redirect
          to={{
            pathname: '/histoires-de-rugby/resultats-de-recherche',
            state: {
              queryCentenaire: this.state.queryCentenaire ? this.state.queryCentenaire : '*',
              redirect: false
            }
          }}
        />
      );
    }

    return (
      <div className="search-club__wrapper mb-5 mb-md-3" ref={input => (this._input = input)}>
        <div className="input input--search ">
          <input
            type="search"
            id="yagd2adssd3"
            placeholder="Ville, nom de club ou année"
            autoComplete="off"
            defaultValue={this.state.queryCentenaire}
            onClick={this.props.handleInputClicked}
            onChange={this.handleInputChanged}
            aria-label={'Cherchez une ville, un nom de club ou une année'}
          />
        </div>
        <button
          className="btn btn--white"
          type="submit"
          onClick={handleTagEvent(
            'recherche_centenaire',
            'recherche',
            this.state.queryCentenaire,
            userPref,
            this.handleSubmit
          )}
        >
          <i className="icon icon-search" />
          <span>{'Rechercher parmi les souvenirs'}</span>
        </button>
        {(this.state.cities.length + this.state.clubs.length) > 0 && 
        <div className="search-club__autocompletion">
          <div>
            {this.state.cities.length > 0 &&
            <Fragment>
            <p className="ft-500 mb-1 mb-md-2">Villes</p>
            <ul>{this.renderCities()}</ul>
            </Fragment>}
          </div>
          <div>
            {this.state.clubs.length > 0 &&
            <Fragment>
            <p className="ft-500 mb-1 mb-md-2">Clubs</p>
            <ul>{this.renderClubs()}</ul>
            </Fragment>}
          </div>
        </div>}
      </div>
    );
  }
}

export default CentenaireSearch;
